import React, { useState } from 'react'
import { Segment, Form, Button, Dimmer, Loader,TextArea} from 'semantic-ui-react';
import { Formik, Field } from 'formik';
import Products from '../../Data/Products';
import ReactDatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import APIService from '../../Services/API/APIService';
import * as Yup from "yup";
import { toast } from "react-toastify";
const CreateActivity = (prop) => {


    const today = dayjs()
    const checkin = dayjs(prop.booking?.checkin).toDate()
    const validDate = today.diff(checkin, 'day')
    const [loading, setLoading] = useState(false)
    const addActivity = async (values) => {
        try {
            setLoading(true)
            let response = await APIService.postData('/guest-house/saveActivity', {

                reference: prop.booking?.reference,
                price: values.price,
                date: values.date,
                name: values.name,
                status: values.status,
                description: values.description,
                GuestHouseUserId: prop.booking?.GuestHouseUser?.id,
                GuestHouseBookingId: prop.booking?.id,
                bookingCode: prop.booking?.bookingId,
                GuestHousePaymentId: prop.booking.GuestHousePaymentId

            })
            setLoading(false)
            prop?.toggleBookingModal(false)
            if (response) {
                toast.success('Created succesfully')
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    const schema = Yup.object().shape({
        name: Yup.string().required("Required"),
        price: Yup.number().required("Required"),
        date: Yup.date().required("Required"),
        status: Yup.string().required("Required"),
        description: Yup.string().required("Required"),


    });

    return (
        <div>

            {loading && (
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            )}

            <Segment textAlign="left" loading={loading}>

                <Formik
                    enableReinitialize={true}
                    initialValues={{

                        price: '',
                        date: "",
                        name: '',
                        status: '',
                        description: ''
                    }}
                    validationSchema={schema}
                    onSubmit={addActivity}
                >
                    {(props) => {
                        const {
                            values,
                            touched,
                            errors,
                            handleChange,
                            handleSubmit,
                        } = props;
                        return (
                            <Form onSubmit={handleSubmit}>
                                <Form.Group widths={3}>
                                    <Form.Field>
                                        <label>Products</label>
                                        <Field
                                            as="select"
                                            name="type"
                                            value={values.name || ""}
                                            onChange={(value) => {
                                                value.persist();
                                                let item = value.target.value;

                                                props.setFieldValue("name", item);

                                            }}
                                            error={touched.name && errors.name}
                                        >
                                            <option value="" disabled defaultValue hidden>
                                                Select Service
                                            </option>

                                            {Products.PRODUCTS?.map((item) => (

                                                <option key={item.id} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Field>
                                    </Form.Field>

                                    <Form.Field>
                                        <label>Payment options</label>
                                        <Field
                                            as="select"
                                            name="type"
                                            value={values.status || ""}
                                            onChange={(value) => {
                                                value.persist();
                                                let item = value.target.value;

                                                props.setFieldValue("status", item);

                                            }}
                                            error={touched.status && errors.status}
                                        >
                                            <option value="" disabled defaultValue hidden>
                                                Select Payment Option
                                            </option>

                                            {Products.PAYMENT_OPTIONS.slice(0,2)?.map((item) => (

                                                <option key={item.id} value={item.name}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Field>
                                    </Form.Field>

                                    <Form.Field>
                                        <label>Description</label>
                                        <TextArea
                                            rows={2}
                                            placeholder="description"
                                            name="description"
                                            value={values.description}
                                            onChange={handleChange}
                                            error={touched.description && errors.description}
                                        />


                                    </Form.Field>

                                </Form.Group>


                                <Form.Group widths={2}>
                                    <Form.Input
                                        type='number'
                                        placeholder="Price"
                                        name="price"

                                        value={values.price}
                                        onChange={handleChange}
                                        error={touched.price && errors.price}
                                    />
                                    <Form.Input
                                        control={ReactDatePicker}
                                        placeholderText="Select a date"
                                        minDate={validDate > 0 ? dayjs().toDate() : dayjs(prop.booking?.checkin).toDate()}
                                        maxDate={dayjs(prop.booking?.checkout).toDate()}

                                        selected={
                                            values.date
                                                ? dayjs(values.date).toDate()
                                                : ""
                                        }
                                        onChange={(value) => {
                                            props.setFieldValue("date", value);
                                        }}
                                    />

                                </Form.Group>

                                <Button style={{ backgroundColor: '#26f09e', color: '#000000' }} content="Add" />
                            </Form>
                        );
                    }}
                </Formik>

            </Segment>

        </div>
    )
}

export default CreateActivity